import { Controller } from "@hotwired/stimulus"

// The comparison on /roles: a role joins it from the menu in its card's
// corner, and the tray listing the chosen roles appears once one has.
//
// With no script the menus still open, the boxes still tick, the tray is
// drawn shown and the comparison page says what to choose if a reader ticks
// one or four. With one, the tray stays out of the way until it has
// something to say, the button waits for the second role and a fourth cannot
// be added, so the page never has to say it. The count is announced politely,
// because a choice that stops being offered without a word looks broken.
export default class extends Controller {
  static targets = ["box", "submit", "status", "tray", "list"]
  static values = { minimum: Number, maximum: Number }

  connect() {
    this.update()
  }

  update(event) {
    const chosen = this.boxTargets.filter((box) => box.checked)
    const full = chosen.length >= this.maximumValue

    this.boxTargets.forEach((box) => {
      box.disabled = full && !box.checked
    })
    this.submitTargets.forEach((submit) => {
      submit.disabled = chosen.length < this.minimumValue
    })
    if (this.hasTrayTarget) this.trayTarget.hidden = chosen.length === 0
    if (this.hasListTarget) this.listTarget.replaceChildren(...chosen.map((box) => this.entry(box)))
    if (this.hasStatusTarget) this.statusTarget.textContent = this.status(chosen.length)

    // The menu the choice was made in has done its job.
    const menu = event?.target.closest("details")
    if (menu) menu.open = false
  }

  remove(event) {
    const box = this.boxTargets.find((candidate) => candidate.value === event.params.slug)
    if (!box) return

    box.checked = false
    this.update()
  }

  status(count) {
    if (count === 0) return `Choose ${this.minimumValue} or ${this.maximumValue} roles to compare`
    if (count < this.minimumValue) return `Choose at least one more role to compare`
    if (count < this.maximumValue) return `${count} chosen. You can add one more.`
    return `${count} chosen, the most a comparison holds`
  }

  entry(box) {
    const item = document.createElement("li")
    item.className = "browse-compare__item"
    const name = document.createElement("span")
    name.textContent = box.dataset.title
    const remove = document.createElement("button")
    remove.type = "button"
    remove.className = "browse-compare__remove"
    remove.textContent = "Remove"
    remove.setAttribute("aria-label", `Remove ${box.dataset.title} from the comparison`)
    remove.dataset.action = "role-compare#remove"
    remove.dataset.roleCompareSlugParam = box.value
    item.append(name, remove)
    return item
  }
}
